import x from "./_common.js";
import { createTheme as y } from "../../../_mixins/use-theme.js";
import z from "../../../_styles/common/light.js";
import H from "../../scrollbar/styles/light.js";
import L from "../../../empty/styles/light.js";
function v(i) {
  const {
    borderRadius: r,
    popoverColor: n,
    textColor3: l,
    dividerColor: a,
    textColor2: e,
    primaryColorPressed: p,
    textColorDisabled: g,
    primaryColor: o,
    opacityDisabled: m,
    hoverColor: t,
    fontSizeTiny: c,
    fontSizeSmall: h,
    fontSizeMedium: s,
    fontSizeLarge: C,
    fontSizeHuge: d,
    heightTiny: S,
    heightSmall: u,
    heightMedium: f,
    heightLarge: b,
    heightHuge: T
  } = i;
  return Object.assign(Object.assign({}, x), {
    optionFontSizeTiny: c,
    optionFontSizeSmall: h,
    optionFontSizeMedium: s,
    optionFontSizeLarge: C,
    optionFontSizeHuge: d,
    optionHeightTiny: S,
    optionHeightSmall: u,
    optionHeightMedium: f,
    optionHeightLarge: b,
    optionHeightHuge: T,
    borderRadius: r,
    color: n,
    groupHeaderTextColor: l,
    actionDividerColor: a,
    optionTextColor: e,
    optionTextColorPressed: p,
    optionTextColorDisabled: g,
    optionTextColorActive: o,
    optionOpacityDisabled: m,
    optionCheckColor: o,
    optionColorPending: t,
    optionColorActive: "rgba(0, 0, 0, 0)",
    optionColorActivePending: t,
    actionTextColor: e,
    loadingColor: o
  });
}
const M = y({
  name: "InternalSelectMenu",
  common: z,
  peers: {
    Scrollbar: H,
    Empty: L
  },
  self: v
}), j = M;
export {
  j as default,
  v as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/select-menu/styles/light.js
// module id = 320
// module chunks = 67